import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from "angularfire2/firestore";
import { Message } from "../models/message";
import { Observable } from "rxjs/Observable";

@Injectable()
export class MessagingService {
  messageCollection: AngularFirestoreCollection<Message> = this.db.collection(
    "messages"
  );
  messageObs = this.messageCollection.valueChanges();

  constructor(public db: AngularFirestore) {}

  getAllMessages() {
    return this.messageCollection.valueChanges();
  }

  getMyMessages(uid) {
    return this.db.collection("messages", ref => {
      return ref.where("sendTo", "==", uid);
    });
  }

  getMyArchive(uid) {
    return this.db.collection("messages", ref => {
      return ref.where("archived", "==", true);
    });
  }

  sendMessage(message: Message) {
    this.messageCollection.add(message).then(result => {
      this.updateMessage(result.id);
      console.log(result);
    });
  }

  updateMessage(id) {
    const messageRef = this.db.doc(`messages/${id}`);
    const data = {
      messageId: id,
      createdAt: new Date(),
      updatedOn: new Date()
    };
    return messageRef.update(data);
  }

  deleteMessage(mId) {
    const messageRef = this.db.doc(`messages/${mId}`);
    return messageRef.delete();
  }

  markRead(mId, b) {
    const messageRef = this.db.doc(`messages/${mId}`);

    const data = {
      active: b,
      updatedOn: new Date()
    };
    return messageRef.update(data);
  }

  archiveMessage(mId, b) {
    const messageRef = this.db.doc(`messages/${mId}`);
    const data = {
      archived: b,
      updatedOn: new Date()
    };
    return messageRef.update(data);
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/services/messaging.service.ts